import { ConversationMessageInput } from '@modules/conversation-message/ConversationMessageInput';
import { styled } from '@mui/material';
import { Editor } from '@tiptap/react';

export const ChatChannelQuickMessageInput = ({
  editor,
  className,
  onTextMessage,
}: {
  editor: Editor;
  className?: string;
  onTextMessage: (message: string) => void;
}) => {
  return (
    <StyledChatChannelQuickMessageInput
      className={className}
      editor={editor}
      allowAskAi={false}
      allowAudio={false}
      allowEmoji
      allowReply={false}
      allowScreenRecord={false}
      allowOptions={false}
      allowSoundBoard={false}
      handleTextMessage={onTextMessage}
      handleFileSelect={() => {}} //? this is not in use without
    />
  );
};

const StyledChatChannelQuickMessageInput = styled(ConversationMessageInput)(
  ({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1.5),
    gap: theme.spacing(0.3),
  }),
);
